import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { FaxV1 } from '@frontend/api-fax';
import { getUser } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { useFaxTagNotification, useNotificationSettingsShallowStore } from '@frontend/notifications';
import { GetWeavePopNotificationByType } from '@frontend/types';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useFaxTagEventSubscription = () => {
  const { create } = useFaxTagNotification();
  const { t } = useTranslation('notifications');
  const { notificationSettings } = useNotificationSettingsShallowStore('notificationSettings');
  const { updateFaxInListFaxCache } = FaxV1.FaxQueryUpdaters.useListFaxQueryUpdater();
  const user = getUser();

  return useWebsocketEventSubscription(NotificationType.FAX_TAG, (payload) => {
    updateFaxInListFaxCache({ faxId: payload.params.faxId, locationId: payload.params.locationId });
    const name = `${payload.params.contact?.firstName} ${payload.params.contact?.secondName}`;
    const notification = {
      id: payload.id,
      timestamp: Date.now(),
      type: 'fax-tag',
      payload: {
        ...payload.params,
      },
      state: {
        paused: false,
        timeout: notificationSettings.durationMs,
        status: 'unread',
      },
    } satisfies GetWeavePopNotificationByType<'fax-tag'>;
    if (payload.params.event === 'APPLIED' && payload.params.userId !== user?.userID) {
      create(notification, {
        os: {
          title: t('Fax'),
          body: `${name} ${payload.params.contact?.faxNumber}`,
        },
      });
    }
    return;
  });
};
